'use strict';
const angular = require('angular');

export class headerDropdownMenuComponent {
  /*@ngInject*/
  constructor() {
  }
}

export default angular.module('conduuApp.headerDropdownMenu', [])
  .component('headerDropdownMenu', {
    template: require('./header-dropdown-menu.component.html'),
    bindings: {
      title: '@',
      menu: '<'
    },
    controller: headerDropdownMenuComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/header-dropdown-menu/header-dropdown-menu.component.js